import Vue from 'vue'
import CONFIG from './../../config.js'

let actions = {
  
  addLog (context, params) {
    context.commit("addLog", params)
  },
  removeLog (context, params) {
    context.commit("removeLog", params)
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/request/actions.js